module.exports = __webpack_public_path__ + "static/assets/c4e6245a088efe8c599b16f96aa20f02.svg";